import { HttpMethod, Performer } from '../core'

export class ClaimTask extends Performer<
  {
    payload: {
      userTaskId: number
    }
  },
  {
    success: boolean
  }
> {
  protected method = HttpMethod.POST
  protected url = '/claim-task'
}
